export default function hasSteeringAccess(user, districtid) {
  const district = districtid !== '-' ? parseInt(districtid, 10) : districtid;
  return user.control || user.steering.includes(district);
}
